const _eventDate = Symbol();
const _description = Symbol();

const coalesce = (...args) => args.find(v => v !== undefined);

export class TriggeredEvent {
	constructor(eventDate, description) {
		this.eventDate = eventDate;
		this.description = description;
	}
	get eventDate() {
		return this[_eventDate];
	}
	set eventDate(v) {
		if(!Number.isInteger(v))
			throw new TypeError('eventDate must be an integer.');
		this[_eventDate] = v;
	}
	get description() {
		return this[_description];
	}
	set description(v) {
		if(typeof v !== 'string')
			throw new TypeError('description must be a string.');
		this[_description] = v;
	}
	toJSON() {
		return {
			eventDate: this.eventDate,
			description: this.description
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.eventDate, obj.EventDate, null),
			coalesce(obj.description, obj.Description, null)
		);
	}
}
